import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fmtMoney, fmtErr } from "../../api";
import Layout from "../../components/Layout";
import { toast } from "sonner";
import { Plus } from "@phosphor-icons/react";

export default function Jobs() {
  const [jobs, setJobs] = useState(null);
  const [summary, setSummary] = useState([]);

  useEffect(() => {
    api.get("/jobs").then((r) => setJobs(r.data)).catch((e) => toast.error(fmtErr(e)));
    api.get("/jobs/summary").then((r) => setSummary(r.data)).catch(() => {});
  }, []);

  return (
    <Layout title="Project jobs">
      <Link to="/jobs/new" data-testid="new-job-btn"
        className="mb-6 flex h-14 w-full items-center justify-center gap-2 rounded-md bg-primary font-bold text-primary-foreground">
        <Plus size={20} weight="bold" /> New project quote
      </Link>

      {summary.length > 0 && (
        <section className="mb-8" data-testid="jobs-summary">
          <p className="label-caps mb-2">Win rate by month</p>
          <div className="card-flat overflow-x-auto p-4">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-xs text-muted-foreground">
                  <th className="pb-2 pr-3">Month</th><th className="pb-2 pr-3 text-right">Quoted</th><th className="pb-2 pr-3 text-right">Won</th>
                  <th className="pb-2 pr-3 text-right">Lost</th><th className="pb-2 pr-3 text-right">Win %</th><th className="pb-2 text-right">Avg margin</th>
                </tr>
              </thead>
              <tbody>
                {summary.map((m) => (
                  <tr key={m.month} className="border-t border-border" data-testid={`summary-${m.month}`}>
                    <td className="py-2 pr-3 font-semibold">{m.month}</td>
                    <td className="py-2 pr-3 text-right">{fmtMoney(m.quoted)}</td>
                    <td className="py-2 pr-3 text-right text-primary">{fmtMoney(m.won)}</td>
                    <td className="py-2 pr-3 text-right text-destructive">{fmtMoney(m.lost)}</td>
                    <td className="py-2 pr-3 text-right font-bold">{m.win_rate != null ? `${m.win_rate}%` : "—"}</td>
                    <td className="py-2 text-right">{m.avg_margin != null ? `${m.avg_margin}%` : "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      )}

      <div className="space-y-2" data-testid="jobs-list">
        {!jobs && <p className="text-muted-foreground">Loading…</p>}
        {jobs?.length === 0 && <p className="card-flat p-6 text-sm text-muted-foreground">No project jobs yet. Decks, fencing, landscaping — quote them here.</p>}
        {jobs?.map((j) => (
          <Link key={j.id} to={`/jobs/${j.id}`} data-testid={`job-row-${j.id}`}>
            <div className="card-flat flex items-center justify-between p-4 transition-colors hover:bg-muted/50">
              <div>
                <p className="font-semibold">{j.title}</p>
                <p className="text-sm text-muted-foreground">{j.property_name} · {j.owner_name}</p>
              </div>
              <div className="text-right">
                <p className="font-heading font-bold text-primary">{fmtMoney(j.total)}</p>
                <p className="text-xs font-bold uppercase text-muted-foreground">{j.status}{j.status === "lost" && j.lost_reason ? ` · ${j.lost_reason}` : ""}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </Layout>
  );
}
